import { validateTextResponse } from './APIUtils';

export const authenticateCode = code => {
  const url = `/api/qikserve/gfc2/security/token?code=${code}`;
  const request = {
    method: 'get'
  };

  return fetch(url, request)
    .then(response => {
      return validateTextResponse(response);
    })
    .then(text => {
      return text;
    })
    .catch(error => {
      throw new Error(error);
    });
};
